function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { DisplayOptions } from 'common/report/insights/util/types';
import { AnalysisType, ChartPlotStyle, ChartType, ValueRepresentationType } from 'common/types/reports/bookmark';
import { CardSnabbdom } from '../chart-card';
const BEHAVIOR = [{
  behavior: {
    type: "event",
    resourceType: "events",
    search: "",
    profileType: null,
    filters: [],
    dataGroupId: null,
    dataset: "$mixpanel"
  },
  measurement: {
    math: "total",
    property: null,
    cumulative: false,
    perUserAggregation: null,
    rolling: null
  }
}, {
  behavior: {
    type: "event",
    resourceType: "events",
    search: "",
    profileType: null,
    filters: [],
    dataGroupId: null,
    dataset: "$mixpanel"
  },
  measurement: {
    math: "total",
    property: null,
    cumulative: false,
    perUserAggregation: null,
    rolling: null
  }
}, {
  behavior: {
    type: "event",
    resourceType: "events",
    search: "",
    profileType: null,
    filters: [],
    dataGroupId: null,
    dataset: "$mixpanel"
  },
  measurement: {
    math: "total",
    property: null,
    cumulative: false,
    perUserAggregation: null,
    rolling: null
  }
}, {
  behavior: {
    type: "event",
    resourceType: "events",
    search: "",
    profileType: null,
    filters: [],
    dataGroupId: null,
    dataset: "$mixpanel"
  },
  measurement: {
    math: "total",
    property: null,
    cumulative: false,
    perUserAggregation: null,
    rolling: null
  }
}];

// TODO: Consolidate common fields
const chartProps = (events: string[], cardTitle?: string) => {
  const displayOptions: DisplayOptions = {
    chartType: ChartType.Bar,
    plotStyle: ChartPlotStyle.Standard,
    analysis: AnalysisType.Linear,
    value: ValueRepresentationType.Absolute,
    funnelStepsSelectedTableColumns: null
  };
  return {
    cardTitle,
    chartOptions: {
      type: "bar"
    },
    bookmark: {
      dashboard: {},
      params: {
        sections: {
          cohorts: [],
          filter: [],
          formula: [],
          group: [],
          show: events.map((ev, ind) => {
            return _objectSpread(_objectSpread({}, BEHAVIOR[ind]), {}, {
              name: ev
            });
          }),
          time: [{
            dateRangeType: "in the last",
            window: {
              unit: "day",
              value: 30
            },
            unit: "day"
          }]
        },
        columnWidths: {
          bar: {}
        },
        displayOptions,
        sorting: {}
      },
      can_view: true,
      allow_staff_override: false,
      is_superadmin: false
    },
    chartParams: {
      computed_at: "2023-11-19T14:40:36.517040+00:00",
      headers: ["$event"],
      date_range: {
        from_date: "2023-10-20T00:00:00-07:00",
        to_date: "2023-11-19T06:41:48.638716-08:00"
      },
      meta: {
        min_sampling_factor: 1,
        time_period_settings: {
          quarter_start_month: 1
        },
        report_sections: {
          group: [],
          show: events.map(ev => ({
            metric_key: ev
          }))
        }
      },
      series: events.reduce((acc, ev) => {
        acc[ev] = {
          all: Math.round(Math.random() * 10000)
        };
        return acc;
      }, {})
    },
    dataGroups: null
  };
};

// eslint-disable-next-line react/destructuring-assignment
export const BarPreview = (_ref: {
  events: string[];
  cardTitle?: string;
}) => {
  let {
    events,
    cardTitle
  }: {
    events: string[];
    cardTitle?: string;
  } = _ref;
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events, cardTitle)} data-sentry-element="CardSnabbdom" data-sentry-component="BarPreview" data-sentry-source-file="bar.tsx" />;
};